<template>
  <v-card class="theme-bg-card-interface">
    <div>
  
      <sequential-entrance fromBottom delay="500" >
  
  <v-container>
    <v-row no-gutters>
  
  
  <v-col>   
      <template v-for="(item, index) in items">
        <v-list-item two-line :key="index">
          <v-list-item-content>
            <v-list-item-title>{{item.title}}</v-list-item-title>
            <v-list-item-subtitle>Command : {{item.explanation}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-for="(item, index) in items2">
        <v-list-item two-line :key="index">
          <v-list-item-content>
            <v-list-item-title>{{item.title}}</v-list-item-title>
            <v-list-item-subtitle>Command : {{item.explanation}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
  </v-col>
  
  <v-col>   
          <template v-for="(item, index) in items3">
        <v-list-item two-line :key="index">
          <v-list-item-content>
            <v-list-item-title>{{item.title}}</v-list-item-title>
            <v-list-item-subtitle>Command : {{item.explanation}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
  </v-col>
  
     <v-col>      
  
    <youtube class="video-card-interface" :video-id="videoId" width="860" height="480" :player-vars="playerVars" @playing="playing"></youtube>
  
  
  </v-col>
  
    </v-row>
  </v-container>
  
      </sequential-entrance>
    </div>
  </v-card>
  </template>
  
  <script>
  export default {
    name: "command assistant",
    components: {},
    data() {
      return {
        media: null,
        videoId: 'nCy5k3eS0h0',
        playerVars: {
          autoplay: 1
        },
        items: [
          {
            title: "Play Cogneetiv Demo",
            explanation: "Play Demo",
          },
          {
            title: "Closes the window",
            explanation: "Close",
          },
         {
            title: "Find/Search in google",
            explanation: "Google News about Tesla",
          },
        ],
  
        items2: [
          {
            title: "Ask for Date",
            explanation: "What is the date?",
          },
          {
            title: "Ask time",
            explanation: " what time is it?",
          },
          {
            title: "Navigate to Screen by Voice command",
            explanation: "Navigate to Dashboard",
          },
        ],
  
        items3: [
          {
            title: "Review your daily Responsibilities",
            explanation: "Start Briefing",
          },
          {
            title: "Create a new Invoice",
            explanation: "Create Invoice",
          },
          {
            title: "Create a new Purchase Order",
            explanation: "Create Purchase Order",
          },
          {
            title: "Create a new Buyback Order",
            explanation: "Create Buyback Order",
          },
        ],
   components: {
  
    },
    methods: {
      playing() {
        console.log('We are watching!!!')
      }
    }
      };
    },
  };
  </script>
  
  <style>
  
  
  .video-card-interface {
   background: rgba(48, 64, 87, 0.1);
   box-shadow: 0 0 5px rgba(90,128,191,.4), inset 0 0 0px rgba(90,128,191,.2), 0 0px 0 #000;
   color: #efe;
   height: 450px;
   width: 800px;
   padding: 10px;
  }
  .space {
    height: 100px;
  }
  .space1 {
    height: 30px;
  }
  .mrgn-top {
    text-align: center;
  }
  .center-aligned {
    text-align: center;
    color: rgb(58, 57, 57);
  }
  h3 {
    color: #888;
  }
  </style>
  